// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WeekDetailEmpty_wrapper","week-spanned":"WeekDetailEmpty_week-spanned","weekSpanned":"WeekDetailEmpty_week-spanned"};